import { GET_CLIENT_TOKEN, ORDER_STATUS, SUBMIT_PAYMENT } from '@gameday/common/constants/endpoints'

export default {
  submitPayment: SUBMIT_PAYMENT, // 'gamedayapi/payment/payments',
  braintreeClientToken: GET_CLIENT_TOKEN, // 'gamedayapi/payment/client_token',
  getOrderStatus: ORDER_STATUS, // 'gamedayapi/orders/status',
}
